import $ from 'jquery';

$(function() {
    var myAccountDelete = $('#cwm_deleteAccount_yesdelete');
    myAccountDelete.on('click', function(){
        $('html').css({ 'overflow-y': "hidden" });
        $("#cwm-overlay").show();
        $.ajax({ 
            type: "DELETE",
            url: "/api/sitecore/CWMAccountManagement/DeleteBankDetails",
            success: function (response) { 
                console.log(response.success);
                window.location.reload();    
            },
            error: function (response) { 
                $('html').css({ 'overflow-y': "scroll" });
                $("#cwm-overlay").hide();                      
                console.log(response.error);
            }  
         });
    });
});


// WEBPACK FOOTER //
// ./components/cwm-deleteAccount-details/scripts/cwm-deleteAccount-details.js